import './style.scss';

import { Page } from 'components';
import { useIsMobile, useReducer, useWithDispatch } from 'hooks';
import { createElement, useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import { Cookies } from 'services';
import { setGridSize } from 'store/profile/actions';
import profileReducer from 'store/profile/reducer';
import { name } from 'store/profile/reducer';

import { AvailableSections, baseURL } from './consts';
import Header from './Header';
import Sections from './Sections';

const Profile = () => {
    useReducer(name, profileReducer);
    const history = useHistory();
    const { tab = AvailableSections.Closet } = useParams<{ tab: AvailableSections }>();
    const [section, setSection] = useState<any>();
    const isMobile = useIsMobile();
    const setGridSizeAction = useWithDispatch(setGridSize);

    useEffect(() => {
        const { token } = Cookies.get('user');
        if (!token) history.push('/');

        if (isMobile) setGridSizeAction('small');
    }, []);

    useEffect(() => {
        if (Sections[tab]) {
            setSection(Sections[tab]);
        } else {
            history.push(`${baseURL}/${AvailableSections.Closet}`);
        }
    }, [tab]);

    const onMenuSelect = (selection: string) => history.push(`${baseURL}/${selection}`);

    return (
        <Page footer={false}>
            <Container className="profile" fluid>
                <Header onMenuSelect={onMenuSelect} active={tab} />

                <Row className="content">
                    <Col> {section ? createElement(section) : ''}</Col>
                </Row>
            </Container>
        </Page>
    );
};

export default Profile;
